import type { SubEntryType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import type { FunctionComponent } from "react"
import { ImageThumbnail } from "./ImageThumbnail"
import { NoteInput } from "./NoteInput"
import { SubEntryFormButtons } from "./SubEntryFormButtons"
import { UploadImage } from "./UploadImage"
import styles from "src/styles/entryModal.module.scss"
import type {
  EditableSubEntry,
  EditableUserEntry,
} from "src/types"

interface Props<T extends SubEntryType> {
  currentSubEntry: EditableSubEntry<T>;
  currentUserEntry: EditableUserEntry;
  updateSubEntry: (s: Partial<EditableSubEntry<T>>) => void;
  readOnly?: boolean;
  // a dialog heading and / or body that will be shown as a warning to the user
  SaveWarning?: FunctionComponent;
  hideImage?: boolean;
  allowCreateWithoutChanges?: boolean;
}

export function SubEntryFooter<T extends SubEntryType>(props: Props<T>) {
  const {
    currentSubEntry,
    currentUserEntry,
    updateSubEntry,
    readOnly = false,
    SaveWarning,
    hideImage = false,
    allowCreateWithoutChanges = false,
  } = props

  return (
    <>
      {(!readOnly || currentSubEntry.note) && (
        <div className={styles.row}>
          <NoteInput
            currentSubEntry={currentSubEntry}
            updateSubEntry={updateSubEntry}
            readOnly={readOnly}
            required={
              !readOnly &&
              currentSubEntry.subentry_type === ActivityType.Note &&
              !currentSubEntry.image_id
            }
          />
          {!readOnly && (
            <UploadImage
              updateSubEntry={updateSubEntry}
              required={
                currentSubEntry.subentry_type === ActivityType.Note &&
                !currentSubEntry.note &&
                !currentSubEntry.image_id
              }
            />
          )}
        </div>
      )}
      {!hideImage && (
        <ImageThumbnail
          currentSubEntry={currentSubEntry}
          updateSubEntry={updateSubEntry}
          readOnly={readOnly}
        />
      )}
      {!readOnly && (
        <SubEntryFormButtons
          currentSubEntry={currentSubEntry}
          currentUserEntry={currentUserEntry}
          SaveWarning={SaveWarning}
          allowCreateWithoutChanges={allowCreateWithoutChanges}
        />
      )}
    </>
  )
}
